export default {
    state: {
        model_id: null,
        models: [],
        model: [],
        errors: {},
        form: {
            code: '',
            name: '',
            description: '',
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'description', label: 'Description', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },

        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },

    },

    getters: {
        getProductModelTableFields: state => state.table.fields,

        getProductModelMeta: state => state.meta,

        getProductModelsForm: state => state.form,

        getProductModelsErrors: state => state.errors,

    },

    mutations: {
        resetProductModelsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setProductModelsForm: state => {
            state.form = {
                code: '',
                name: '',
                description: '',
            };

            state.errors = {};
        },

        setProductModels: (state, payload) => {
            state.models = payload;
        },

        setProductModelsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setProductModelErrors: (state, payload) => {
            state.errors = payload;
        },

        setProductModelsErrors: (state, payload) => {
            state.errors = payload;
        },

    },

    actions: {
        fetchProductModels: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const models = {
                "data": [
                    {
                        "unit_id": 1,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile",
                                "description": "text here 1",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/1"}
                    },
                    {
                        "unit_id": 2,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Mobile",
                                "description": "text here 2",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/2"}
                    },
                    {
                        "unit_id": 3,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Mobile",
                                "description": "text here 3",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "models\/3"}
                    }
                ],
                "links": {
                    "self": "\/models",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/models?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/models?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/models?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/models",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setProductModels', models);

                commit('setProductModelsMeta', models.meta);

                resolve(models);
            });
        },

        fetchEditProductModel: ({state, commit}, model_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + model_id + '/edit')
                    .then(response => {
                        state.model_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitProductModel: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductModelErrors', error.response.data.errors);

                        reject();
                    });
            })
        },
        updateProductModel: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.unit_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductModelsErrors', error.response.data.errors);

                        reject();
                    });
            })
        },


    }
}
